
import React from "react";
import { Check } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";

interface ReviewStepProps {
  businessData: {
    name: string;
    industry: string;
    website: string;
    brandVoice: string;
    description: string;
    keywords: string[];
  };
}

const ReviewStep: React.FC<ReviewStepProps> = ({ businessData }) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-2 mb-4">
        <Check className="text-primary h-6 w-6" />
        <h3 className="text-2xl font-medium">Review & Finish</h3>
      </div>
      
      <Separator />

      <div className="space-y-4">
        <div className="space-y-2">
          <h4 className="text-lg font-medium">Business Information</h4>
          <div className="grid grid-cols-2 gap-4 p-4 bg-muted/20 rounded-lg">
            <div>
              <p className="text-sm text-muted-foreground">Name</p>
              <p className="font-medium">{businessData.name || "Not provided"}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Industry</p>
              <p className="font-medium">{businessData.industry || "Not provided"}</p>
            </div>
            <div className="col-span-2">
              <p className="text-sm text-muted-foreground">Website</p>
              <p className="font-medium">{businessData.website || "Not provided"}</p>
            </div>
          </div>
        </div>
        
        <div className="space-y-2">
          <h4 className="text-lg font-medium">Brand Voice</h4>
          <div className="p-4 bg-muted/20 rounded-lg">
            <p className="font-medium">{businessData.brandVoice || "Not provided"}</p>
          </div>
        </div>
        
        <div className="space-y-2">
          <h4 className="text-lg font-medium">Description</h4>
          <div className="p-4 bg-muted/20 rounded-lg">
            <p className="font-medium">{businessData.description || "Not provided"}</p>
          </div>
        </div>
        
        {businessData.keywords.length > 0 && (
          <div className="space-y-2">
            <h4 className="text-lg font-medium">Keywords</h4>
            <div className="flex flex-wrap gap-2 p-4 bg-muted/20 rounded-lg">
              {businessData.keywords.map(keyword => (
                <Badge key={keyword} variant="secondary">
                  {keyword}
                </Badge>
              ))}
            </div>
          </div>
        )}
        
        <div className="mt-6 p-4 bg-primary/5 rounded-lg">
          <p className="text-sm">
            VirtuStaff.ai will analyze your website and use this information to create personalized
            content that aligns with your brand. You can update these details anytime in your settings.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewStep;
